module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', [_c('div', {
    staticClass: "upload-appicon upload-appicon-information-noicon",
    attrs: {
      "title": _vm.formData.appicon ? 'Upload app icon' : 'Edit'
    }
  }, [(!_vm.formData.appicon) ? _c('i', {
    staticClass: "fa fa-plus"
  }) : _vm._e(), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "disabled": _vm.isUploading
    },
    on: {
      "change": function($event) {
        _vm.uploadfile($event)
      }
    }
  })]), _vm._v(" "), (_vm.formData.appicon) ? _c('img', {
    staticClass: "information-appicon",
    attrs: {
      "title": "APP icon",
      "name": "appicon",
      "src": 'https://d.din.bz/' + _vm.formData.appicon
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.progress > 0),
      expression: "progress > 0"
    }],
    staticClass: "upload-progress-bar"
  }, [_c('div', {
    staticClass: "progress progress-xxs active"
  }, [_c('div', {
    staticClass: "progress-bar progress-bar-success progress-bar-striped",
    style: ('width: ' + _vm.progress + '%'),
    attrs: {
      "role": "progressbar",
      "aria-valuenow": _vm.progress,
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v(_vm._s(_vm.progress) + "% Complete")])])])]), _vm._v(" "), _c('div', {
    staticClass: "information-content"
  }, [(_vm.isAppAdmin || _vm.isAdmin) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("APP ID")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.appid),
      expression: "formData.appid"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Text",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.formData.appid)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "appid", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.isAppAdmin || _vm.isAdmin) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("APP Keys")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.appkeys),
      expression: "formData.appkeys"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "App Keys",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.formData.appkeys)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "appkeys", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.isAppAdmin || _vm.isAdmin) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("APP Secret")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.appsecret),
      expression: "formData.appsecret"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "App Secret",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.formData.appsecret)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "appsecret", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.appname),
      expression: "formData.appname"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": !_vm.isAdmin,
      "name": "appname",
      "placeholder": "Suggest fill out the client app name",
      "required": ""
    },
    domProps: {
      "value": (_vm.formData.appname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "appname", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.oemname),
      expression: "formData.oemname"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": !_vm.isAdmin,
      "name": "oemname",
      "placeholder": "OEM name",
      "required": ""
    },
    domProps: {
      "value": (_vm.formData.oemname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "oemname", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Description")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.description),
      expression: "formData.description"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": !_vm.isAdmin,
      "placeholder": "Description",
      "name": "description"
    },
    domProps: {
      "value": (_vm.formData.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "description", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Auto-reply email account")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.appemail),
      expression: "formData.appemail"
    }],
    staticClass: "form-control",
    staticStyle: {
      "margin-bottom": "5px"
    },
    attrs: {
      "type": "text",
      "disabled": !_vm.isAdmin,
      "name": "appemail",
      "placeholder": "Email Account"
    },
    domProps: {
      "value": (_vm.formData.appemail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "appemail", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.appemailpassword),
      expression: "formData.appemailpassword"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": !_vm.isAdmin,
      "name": "appemailpassword",
      "placeholder": "Password"
    },
    domProps: {
      "value": (_vm.formData.appemailpassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "appemailpassword", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("About us")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.aboutme),
      expression: "formData.aboutme"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": !_vm.isAdmin,
      "name": "aboutme",
      "placeholder": "URL"
    },
    domProps: {
      "value": (_vm.formData.aboutme)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "aboutme", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("A website for jumping to after verifying the verification email to show the binding process is successful")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.confirmemail),
      expression: "formData.confirmemail"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": !_vm.isAdmin,
      "placeholder": "URL"
    },
    domProps: {
      "value": (_vm.formData.confirmemail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "confirmemail", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Help")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.helpurl),
      expression: "formData.helpurl"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": !_vm.isAdmin,
      "name": "helpurl",
      "placeholder": "URL"
    },
    domProps: {
      "value": (_vm.formData.helpurl)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "helpurl", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("User privacy policy")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.policy),
      expression: "formData.policy"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": !_vm.isAdmin,
      "name": "policy",
      "placeholder": "URL"
    },
    domProps: {
      "value": (_vm.formData.policy)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "policy", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Contact ID")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.contactid),
      expression: "formData.contactid"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": !_vm.isAdmin,
      "name": "contactid",
      "placeholder": "Contact ID Key"
    },
    domProps: {
      "value": (_vm.formData.contactid)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "contactid", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.isAppAdmin || _vm.isAdmin) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("SMS Config")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.smsconfString),
      expression: "formData.smsconfString"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": !_vm.isAdmin,
      "placeholder": "{}",
      "name": "smsconf"
    },
    domProps: {
      "value": (_vm.formData.smsconfString)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "smsconfString", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.isAppAdmin || _vm.isAdmin) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("jPush Config")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.jpushconfString),
      expression: "formData.jpushconfString"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": !_vm.isAdmin,
      "name": "jpushconf",
      "placeholder": "{}"
    },
    domProps: {
      "value": (_vm.formData.jpushconfString)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "jpushconfString", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.isAppAdmin || _vm.isAdmin) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Mail Config")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.mailconfString),
      expression: "formData.mailconfString"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": !_vm.isAdmin,
      "placeholder": "{}",
      "name": "mailconf"
    },
    domProps: {
      "value": (_vm.formData.mailconfString)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "mailconfString", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.isAppAdmin || _vm.isAdmin) ? _c('div', {
    staticClass: "form-group"
  }, [_vm._m(2), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.feedbackmail),
      expression: "formData.feedbackmail"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": !_vm.isAdmin,
      "placeholder": "Feedbackmail",
      "name": "feedbackmail",
      "required": ""
    },
    domProps: {
      "value": (_vm.formData.feedbackmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "feedbackmail", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.isAppAdmin || _vm.isAdmin) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Allowips")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.allowipsString),
      expression: "formData.allowipsString"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": !_vm.isAdmin,
      "placeholder": "Allowips",
      "name": "allowips"
    },
    domProps: {
      "value": (_vm.formData.allowipsString)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "allowipsString", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.isAppAdmin || _vm.isAdmin) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Shareside")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.shareside),
      expression: "formData.shareside"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": !_vm.isAdmin,
      "placeholder": "Shareside",
      "name": "shareside"
    },
    domProps: {
      "value": (_vm.formData.shareside)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "shareside", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.isAppAdmin || _vm.isAdmin) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Payside")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.payside),
      expression: "formData.payside"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": !_vm.isAdmin,
      "placeholder": "Payside",
      "name": "payside"
    },
    domProps: {
      "value": (_vm.formData.payside)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "payside", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.isAppAdmin || _vm.isAdmin) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Pay Contacts (using multiple lines for multiple contacts)")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.paycontactsString),
      expression: "formData.paycontactsString"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": !_vm.isAdmin,
      "placeholder": "Pay Contact",
      "name": "paycontacts"
    },
    domProps: {
      "value": (_vm.formData.paycontactsString)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "paycontactsString", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.isAppAdmin || _vm.isAdmin) ? _c('div', {
    staticClass: "form-group"
  }, [_vm._m(3), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.notificationconfString),
      expression: "formData.notificationconfString"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": !_vm.isAdmin,
      "placeholder": "{}",
      "name": "notificationconf",
      "required": ""
    },
    domProps: {
      "value": (_vm.formData.notificationconfString)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "notificationconfString", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.isAppAdmin || _vm.isAdmin) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("RDA URL")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.rdaurl),
      expression: "formData.rdaurl"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": !_vm.isAdmin,
      "placeholder": "RDA URL",
      "name": "rdaurl"
    },
    domProps: {
      "value": (_vm.formData.rdaurl)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "rdaurl", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.isAppAdmin || _vm.isAdmin) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Ghome")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.ghome),
      expression: "formData.ghome"
    }],
    attrs: {
      "type": "checkbox",
      "disabled": !_vm.isAdmin,
      "placeholder": "Ghome",
      "name": "ghome"
    },
    domProps: {
      "value": 1,
      "checked": Array.isArray(_vm.formData.ghome) ? _vm._i(_vm.formData.ghome, 1) > -1 : (_vm.formData.ghome)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.formData.ghome,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = 1,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.formData, "ghome", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.formData, "ghome", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.formData, "ghome", $$c)
        }
      }
    }
  })]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("\n        APP Name\n        "), _c('em', [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("\n        OEM Name\n        "), _c('em', [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("\n        Feedback Mail\n        "), _c('em', [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("\n        Notification Conf\n        "), _c('em', [_vm._v("*")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-968f34c8", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-968f34c8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/AppDataForm.vue
// module id = 490
// module chunks = 1